<template>
    <div>
        <b-card :header="uLang('app.create')" header-tag="h4" class="bg-default-card">
            <form-admin-relation></form-admin-relation>
        </b-card>
    </div>
</template>

<script>
    import FormAdminRelation from '~/components/forms/admin/relation/form'

    export default {
        name: 'create',

        components: {
            'form-admin-relation': FormAdminRelation,
        },
    }
</script>

<style lang="css" scoped>
</style>